import React from "react";
import { Link } from "react-router-dom";

export default function Unauthorized() {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-6">
      <div className="w-full max-w-lg text-center">

        {/* Icon */}
        <div className="mx-auto mb-8 flex h-20 w-20 items-center justify-center rounded-full bg-red-50">
          <svg
            className="h-10 w-10 text-red-500"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 3L21 7V12C21 17.2 17.6 20.7 12 22C6.4 20.7 3 17.2 3 12V7L12 3Z" />
            <path d="M12 8V12" />
            <path d="M12 16H12.01" />
          </svg>
        </div>

        {/* Error code */}
        <div className="mb-4 inline-flex items-center rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold uppercase tracking-wider text-slate-500">
          Error 403
        </div>

        {/* Heading */}
        <h1 className="text-4xl font-bold tracking-tight text-slate-900">
          Access Denied
        </h1>

        {/* Description */}
        <p className="mx-auto mt-4 max-w-md text-base leading-7 text-slate-500">
          You don't have permission to access this page. Please contact your
          administrator if you believe this is a mistake.
        </p>

        {/* Buttons */}
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-lg bg-slate-900 px-5 py-3 text-sm font-semibold text-white transition hover:bg-slate-800"
          >
            <svg
              className="h-4 w-4"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M3 12L12 3L21 12" />
              <path d="M5 10V21H19V10" />
              <path d="M9 21V15H15V21" />
            </svg>
            Go to Home
          </Link>

          <button
            type="button"
            onClick={() => window.history.back()}
            className="inline-flex items-center gap-2 rounded-lg border border-slate-300 bg-white px-5 py-3 text-sm font-semibold text-slate-700 transition hover:bg-slate-50"
          >
            ← Go Back
          </button>
        </div>

        {/* Bottom message */}
        <p className="mt-10 text-sm text-slate-400">
          If you need access, please contact your administrator.
        </p>
      </div>
    </div>
  );
}